$(document).on('turbolinks:load', function() {
  function initJapaneseDateInputs() {
    $('.japanese-date-input').each(function() {
      const $input = $(this);
      const $wrapper = $input.closest('.japanese-date-wrapper');
      const $display = $wrapper.find('.japanese-date-display');
      
      let checkInterval = null;
      
      const formatDate = (dateString) => {
        if (!dateString) return '';
        const [year, month, day] = dateString.split('-');
        return `${year}年${month}月${day}日`;
      };
      
      const updateDisplay = () => {
        const value = $input.val();
        if (value) {
          $wrapper.addClass('has-value');
          $display.text(formatDate(value));
        } else {
          $wrapper.removeClass('has-value');
          $display.text('');
        }
      };
      
      const startMonitoring = () => {
        if (checkInterval) return;
        checkInterval = setInterval(updateDisplay, 100);
      };
      
      const stopMonitoring = () => {
        if (checkInterval) {
          clearInterval(checkInterval);
          checkInterval = null;
        }
        updateDisplay();
      };
      
      updateDisplay();
      
      $input.on('input change', updateDisplay);
      $input.on('focus', startMonitoring);
      $input.on('blur', stopMonitoring);
    });
  }
  
  initJapaneseDateInputs();
  
  function getVisibleCheckboxes() {
    return $('input[name="question_ids[]"]:visible');
  }
  
  function updateButtons() {
    const visibleChecked = getVisibleCheckboxes().filter(':checked');
    const checkedCount = visibleChecked.length;
    
    const activeCount = visibleChecked.filter(function() {
      const container = $(this).closest('tr, .mobile-card');
      return !container.find('.restore-single-btn').length;
    }).length;
    
    const deletedCount = visibleChecked.filter(function() {
      const container = $(this).closest('tr, .mobile-card');
      return container.find('.restore-single-btn').length;
    }).length;
    
    $('#bulkDeleteBtn').prop('disabled', activeCount === 0);
    $('#bulkRestoreBtn').prop('disabled', deletedCount === 0);
    
    $('#selectionCount').text(`選択: ${checkedCount} 件`);
  }

  window.toggleAllCheckboxes = function(selectAll) {
    getVisibleCheckboxes().prop('checked', selectAll.checked);
    $('#select-all, #select-all-mobile').prop('checked', selectAll.checked);
    updateButtons();
  };

  $(document).on('change', 'input[name="question_ids[]"]', function(e) {
    e.stopPropagation();
    
    updateButtons();
    const totalCheckboxes = getVisibleCheckboxes().length;
    const checkedCheckboxes = getVisibleCheckboxes().filter(':checked').length;
    
    if (checkedCheckboxes === 0) {
      $('#select-all, #select-all-mobile').prop('checked', false).prop('indeterminate', false);
    } else if (checkedCheckboxes === totalCheckboxes) {
      $('#select-all, #select-all-mobile').prop('checked', true).prop('indeterminate', false);
    } else {
      $('#select-all, #select-all-mobile').prop('checked', false).prop('indeterminate', true);
    }
  });

  function updateModalContent(action, type) {
    if (action === 'delete') {
      const modalBody = $('#deleteModal .modal-body p');
      if (type === 'bulk') {
        const activeCount = getVisibleCheckboxes().filter(':checked').filter(function() {
          const questionId = $(this).val();
          const container = $(this).closest('tr, .mobile-card');
          return !container.find('.restore-single-btn').length;
        }).length;
        modalBody.text(`選択した${activeCount}件の質問を削除しますか？`);
      } else {
        modalBody.text('この質問を削除しますか？');
      }
    } else if (action === 'restore') {
      const modalBody = $('#restoreModal .modal-body p');
      if (type === 'bulk') {
        const deletedCount = getVisibleCheckboxes().filter(':checked').filter(function() {
          const questionId = $(this).val();
          const container = $(this).closest('tr, .mobile-card');
          return container.find('.restore-single-btn').length;
        }).length;

        modalBody.text(`選択した${deletedCount}件の質問を復元しますか？`);
      } else {
        modalBody.text('この質問を復元しますか？');
      }
    }
  }

  function showModal(modalId) {
    const modalElement = document.getElementById(modalId);
    const modal = new bootstrap.Modal(modalElement, {
      backdrop: true,
      keyboard: true,
      focus: true
    });
    
    $('.modal-backdrop').remove();
    $('body').removeClass('modal-open');
    
    modal.show();
  }

  $('#bulkDeleteBtn').on('click', function(e) {
    e.preventDefault();
    e.stopPropagation();
    
    if (getVisibleCheckboxes().filter(':checked').length > 0) {
      window.singleQuestionId = null;
      updateModalContent('delete', 'bulk');
      showModal('deleteModal');
    }
  });

  $('#bulkRestoreBtn').on('click', function(e) {
    e.preventDefault();
    e.stopPropagation();
    
    if (getVisibleCheckboxes().filter(':checked').length > 0) {
      window.singleQuestionId = null;
      updateModalContent('restore', 'bulk');
      showModal('restoreModal');
    }
  });

  function submitBulkAction(action) {
    const urlParams = new URLSearchParams(window.location.search);
    
    const form = $('<form>', {
      method: 'POST',
      action: `/admin/qa/questions/bulk_${action}`
    });
    
    form.append($('<input>', {
      type: 'hidden',
      name: 'authenticity_token', 
      value: $('meta[name="csrf-token"]').attr('content')
    }));
    
    urlParams.forEach((value, key) => {
      if (key !== 'page') {
        form.append($('<input>', {
          type: 'hidden',
          name: key,
          value: value
        }));
      }
    });
    
    if (window.singleQuestionId) {
      form.append($('<input>', {
        type: 'hidden',
        name: 'question_ids[]',
        value: window.singleQuestionId
      }));
      window.singleQuestionId = null;
    } else {
      getVisibleCheckboxes().filter(':checked').each(function() {
        const questionId = $(this).val();
        const container = $(this).closest('tr, .mobile-card');
        const isDeleted = container.find('.restore-single-btn').length > 0;
        
        if ((action === 'delete' && !isDeleted) || (action === 'restore' && isDeleted)) {
          form.append($('<input>', {
            type: 'hidden',
            name: 'question_ids[]',
            value: questionId
          }));
        }
      });
    }
    
    $('body').append(form);
    form.submit();
  }

  $('#confirmDeleteQABtn').on('click', function(e) {
    e.preventDefault();
    e.stopPropagation();
    submitBulkAction('delete');
  });
  
  $('#confirmRestoreBtn').on('click', function(e) {
    e.preventDefault();
    e.stopPropagation();
    submitBulkAction('restore');
  });

  $(document).on('hidden.bs.modal', '.modal', function () {
    $('.modal-backdrop').remove();
    $('body').removeClass('modal-open');
    $('body').css('padding-right', '');
    
    $(this).removeClass('show');
    $(this).attr('aria-hidden', 'true');
    $(this).removeAttr('aria-modal');
    $(this).removeAttr('role');
  });

  $(document).on('click', '.delete-single-btn', function(e) {
    e.preventDefault();
    e.stopPropagation();
    
    const questionId = $(this).data('question-id');
    window.singleQuestionId = null;
    window.singleQuestionId = questionId;
    
    updateModalContent('delete', 'single');
    showModal('deleteModal');
  });

  $(document).on('click', '.restore-single-btn', function(e) {
    e.preventDefault();
    e.stopPropagation();
    
    const questionId = $(this).data('question-id');
    
    window.singleQuestionId = null;
    window.singleQuestionId = questionId;
    
    updateModalContent('restore', 'single');
    showModal('restoreModal');
  });

  const originalSubmitBulkAction = submitBulkAction;
  window.submitBulkAction = function(action) {
    if (window.singleQuestionId) {
      const questionId = window.singleQuestionId;
      window.singleQuestionId = null;
      
      const urlParams = new URLSearchParams(window.location.search);
      
      const form = $('<form>', {
        method: action === 'delete' ? 'DELETE' : 'PATCH',
        action: action === 'delete' 
          ? `/admin/qa/questions/${questionId}/soft_delete`
          : `/admin/qa/questions/${questionId}/restore`
      });
      
      form.append($('<input>', {
        type: 'hidden',
        name: 'authenticity_token',
        value: $('meta[name="csrf-token"]').attr('content')
      }));
      
      urlParams.forEach((value, key) => {
        if (key !== 'page') {
          form.append($('<input>', {
            type: 'hidden',
            name: key,
            value: value
          }));
        }
      });
      
      $('body').append(form);
      form.submit();
    } else {
      originalSubmitBulkAction(action);
    }
  };

  updateButtons();

  $(document).on('click', '.question-row', function(e) {
    if ($(e.target).is('input[type="checkbox"]') || 
        $(e.target).is('button') || 
        $(e.target).is('a') ||
        $(e.target).closest('button').length > 0 ||
        $(e.target).closest('a').length > 0) {
      return;
    }
    
    const questionId = $(this).data('question-id');
    if (questionId) {
      window.location.href = `/admin/qa/questions/${questionId}`;
    }
  });

  if (window.location.search.includes('success=true')) {
    const modal = new bootstrap.Modal(document.getElementById('successModal'));
    modal.show();
    
    const url = new URL(window.location);
    url.searchParams.delete('success');
    window.history.replaceState({}, '', url);
  }
});

// Admin Q&A Edit Form JavaScript with Turbolinks and jQuery
$(document).on('turbolinks:load', function() {
  if (!$('#formQuestions').length || !$('.admin-qa-edit-container').length) return;

  function showValidationMessage(selector, message) {
    const field = $(selector);
    const validationDiv = $(`<div class="validation-message text-danger mt-1" style="font-size: 14px;">${message}</div>`);
    field.after(validationDiv);
    field.addClass('is-invalid');
  }

  function initAdminQACategoryLogic() {
    const categoryRadios = $('.admin-qa-category-radio');
    const subcategorySelect = $('#admin_qa_subcategory_select');
    const originalValue = subcategorySelect.val();
    
    function loadSubcategories(categoryId, keepValue = false) {
      if (!categoryId) return;
      
      subcategorySelect.html('<option value="">読み込み中...</option>').prop('disabled', true);
      
      $.get('/admin/qa/subcategories', { category_id: categoryId })
        .done(function(data) {
          subcategorySelect.html('<option value="">中分類を選んでください</option>');
          data.forEach(sub => subcategorySelect.append(`<option value="${sub.id}">${sub.name}</option>`));
          if (keepValue && originalValue) subcategorySelect.val(originalValue);
          subcategorySelect.prop('disabled', false);
        })
        .fail(function() {
          subcategorySelect.html('<option value="">エラーが発生しました</option>').prop('disabled', false);
        });
    }
    
    categoryRadios.on('change', function() {
      loadSubcategories($(this).val());
    });
    
    const currentCategory = categoryRadios.filter(':checked').val();
    const hasSubcategoryOptions = subcategorySelect.find('option').length > 1;
    
    if (currentCategory && !hasSubcategoryOptions) {
      loadSubcategories(currentCategory, true);
    }
  }
  
  initAdminQACategoryLogic();

  const bodyTextarea = $('textarea[name="question[body]"]');
  const textCount = $('.admin-text-count');
  
  if (bodyTextarea.length && textCount.length) {
    textCount.text(bodyTextarea.val().length);
    
    bodyTextarea.on('input', function() {
      textCount.text($(this).val().length);
      $(this).removeClass('is-invalid');
      $(this).next('.validation-message').remove();
    });
  }

  $('input[name="question[title]"], input[name="question[tag]"]').on('input', function() {
    $(this).removeClass('is-invalid');
    $(this).next('.validation-message').remove();
  });

  $('.admin-preview-question').on('click', function() {
    const checkedRadio = $('.admin-qa-category-radio:checked');
    const categoryName = checkedRadio.length ? checkedRadio.next('.admin-qa-category-label').text().trim() : '';
    const subcategoryName = $('#admin_qa_subcategory_select option:selected').text() || '';
    const title = $('input[name="question[title]"]').val();
    const body = $('textarea[name="question[body]"]').val();
    const tag = $('input[name="question[tag]"]').val();

    $('.validation-message').remove();
    
    let hasError = false;
    
    if (!checkedRadio.length) {
      showValidationMessage('.admin-qa-category-container', '大分類を選択してください。');
      hasError = true;
    }
    
    const selectedSubcategory = $('#admin_qa_subcategory_select').val();
    if (!selectedSubcategory || selectedSubcategory === '') {
      showValidationMessage('#admin_qa_subcategory_select', '中分類を選択してください。');
      hasError = true;
    }
    
    if (!title.trim()) {
      showValidationMessage('input[name="question[title]"]', '題名を入力してください。');
      hasError = true;
    }
    
    if (!body.trim()) {
      showValidationMessage('textarea[name="question[body]"]', '質問内容を入力してください。');
      hasError = true;
    }
    
    if (body.length < 50) {
      showValidationMessage('textarea[name="question[body]"]', '※50文字以上で入力してください。');
      hasError = true;
    }
    
    if (!tag.trim()) {
      showValidationMessage('input[name="question[tag]"]', 'キーワードを入力してください。');
      hasError = true;
    }
    
    if (hasError) {
      return;
    }

    $('.admin-name-special-category').text(categoryName);
    $('.admin-name-subcategory_id').text(subcategoryName);
    $('.admin-question-title').text(title);
    $('.admin-question-body').text(body);
    $('.admin-question-tag').text(tag);

    $('.admin-form-input-question').addClass('d-none');
    $('.admin-form-preview-question').removeClass('d-none');
    
    $('html, body').animate({ scrollTop: 0 }, 50);
  });

  $('.admin-edit-input-question').on('click', function() {
    $('.admin-form-input-question').removeClass('d-none');
    $('.admin-form-preview-question').addClass('d-none');
  });
});